'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Divtable = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_divtable',
		zebring: true,
		zebra_order: 'even', //even or odd
		zebra_class: 'x',
		sortable: false,
		animate_on_sort: true,
		no_data_char: '-',
		first_sort: 'desc'
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.w_divtable');

		if (this._element) this.build();
	},

	build: function build() {
		var opts = this.opts = this.options;
		this._thead = this._element.getElement('.thead');
		this._tbody = this._element.getElement('.tbody');
		this._trs = this._tbody.getElements('.tr');

		this.first_sort = this.options.first_sort;
		this.second_sort = this.options.first_sort == 'desc' ? 'asc' : 'desc';

		if (this._trs.length > 500) {
			opts.animate_on_sort = false;
		}

		if (opts.sortable) {
			this._element.addClass('sortable');
			this.trs = []; //array of objects for sorting

			this._trs.each(function (_el) {
				this.trs.push({
					element: _el
				});
			}.bind(this));

			if (opts.sortable && this._trs.length > 1) {
				this.get_sorting_togglers();
			}
		}

		if (opts.zebring == true) {
			this.zebring();
		}

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			this._element.addClass('_touch');
		}

		this.linking();

		this.add_tr_events();
	},

	add_new_rows: function add_new_rows(rows) {
		var even_or_odd = this._trs.length % 2;

		if (rows && rows.length > 0) {
			rows.each(function (_el) {
				if (!this._trs) {
					this._trs = [];
				}

				this._trs.push(_el);

				if (this.trs) {
					this.trs.push({
						element: _el
					});
				}
			}.bind(this));

			if (this.opts.zebring == true) {
				this.zebring(rows, even_or_odd);
			}

			this.linking(rows);
			this.sorted = false;
		}
	},

	zebring: function zebring(rows, even_or_odd) {
		var opts = this.options,
		    order = 0;

		if (!even_or_odd || even_or_odd == 0) {
			order = opts.zebra_order == 'odd' ? 1 : 0;
		} else {
			order = opts.zebra_order == 'odd' ? 0 : 1;
		}

		var _rows = rows && rows.length > 0 ? rows : this._trs;

		_rows.each(function (_el, i) {
			i = i + order;

			if (i % 2 == 0) {
				_el.removeClass(opts.zebra_class);
			} else {
				_el.addClass(opts.zebra_class);
			}
		});
	},

	linking: function linking(_trs) {
		var _rows = _trs || this._trs;

		_rows.each(function (_el) {
			var href = _el.getAttribute('data-href');

			if (!href || href == '') return;

			var _photo = _el.getElement('.photo');

			if (!_photo) {
				_el.addClass('link');
				_el.addEvent('click', function () {
					window.location = href;
				});
				return;
			}

			_photo = _photo.getElement('.lst_photo') || _photo;

			_photo.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (e.shift || e.control || e.meta || e.alt) {
					var _temp_a = new Element('a', {
						target: "_blank",
						href: href,
						styles: {
							display: "none"
						}
					}).inject(_photo.getParent());

					var custom_event = document.createEvent('MouseEvents');

					custom_event.initMouseEvent('click', true, true, window);
					_temp_a.dispatchEvent(custom_event);
					_temp_a.destroy();
				} else {
					window.location = href;
				}
			});
		});
	},

	get_sorting_togglers: function get_sorting_togglers() {
		if (!this._thead) return;

		this._sorters = this._thead.getElements('.th[data-sort]');

		if (this._thead.hasClass('dropdown')) {
			this.create_dropdown();
		}

		this._sorters.each(function (_el) {
			if (!_el.getElement('.sort_span')) {
				_el.set('html', _el.get('html') + '<span class="sort_span">&nbsp;</span>');
			}

			var data_sort = _el.getAttribute('data-sort');
			data_sort = data_sort.toLowerCase();

			if (data_sort != '') {
				if (!_el.hasClass('.sort')) {
					_el.addClass('sort unsorted');
				}

				_el.addEvent('click', function (e) {
					if (e && e.stop) {
						e.stop();
					}

					_el.removeClass('unsorted');

					this.order = this.first_sort;

					if (_el.hasClass(this.first_sort)) {
						_el.removeClass(this.first_sort);
						_el.addClass(this.second_sort);
						this.order = this.second_sort;
					} else if (_el.hasClass(this.second_sort)) {
						_el.removeClass(this.second_sort);
						_el.addClass(this.first_sort);
					} else {
						_el.addClass(this.first_sort);
						this.sorted = false;
					}

					this.sort(data_sort);

					if (this._prev_sorter && this._prev_sorter != _el) {
						this._prev_sorter.removeClass(this.first_sort);
						this._prev_sorter.removeClass(this.second_sort);
						this._prev_sorter.addClass('unsorted');
					}

					this._prev_sorter = _el;
					this.fireEvent('sorting', [_el]);
				}.bind(this));
			}
		}.bind(this));
	},

	before_sort: function before_sort(sort) {
		this.compare_strings = false;

		this.trs.each(function (_el) {
			var data = 'data-' + sort;
			var value = _el.element.getAttribute(data);

			if (_el.element.getStyle('display') == 'none') {
				this.trs_nottosort.push(_el);
			} else {
				if (!value || value == '' || value == this.opts.no_data_char) {
					this.trs_nottosort.push(_el);
				} else {
					if (value.toFloat()) {
						_el.value = value.toFloat();
					} else {
						_el.value = value;
						this.compare_strings = true;
					}

					this.trs_tosort.push(_el);
				}
			}
		}.bind(this));
	},

	sort: function sort(_sort) {
		var opts = this.options;

		if (!this.sorted) {
			//do not sort if array has been just sorted with this sorter
			this.trs_length = this.trs.length;

			this.trs_tosort = [];
			this.trs_nottosort = [];
			this.before_sort(_sort);

			this.quick_sort(0, this.trs_tosort.length - 1, _sort);

			this.sorted = true;
		}

		var temp_array;
		if (this.order == 'asc') {
			temp_array = Array.clone(this.trs_tosort);
			this.trs = temp_array.append(this.trs_nottosort);
		} else {
			temp_array = Array.clone(this.trs_nottosort);
			this.trs = temp_array.append(this.trs_tosort);
		}

		this._tbody.empty();

		if (opts.animate_on_sort) {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_zebring_animate(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_simple_animate(_el.element, i);
				}.bind(this));
			}
		} else {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					this.insert_element_zebring(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el) {
					this.insert_element_simple(_el.element);
				}.bind(this));
			}
		}
	},

	insert_element_zebring: function insert_element_zebring(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		}
	},

	insert_element_zebring_animate: function insert_element_zebring_animate(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	insert_element_simple: function insert_element_simple(_el) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}
	},

	insert_element_simple_animate: function insert_element_simple_animate(_el, i) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}

		if (this.order == 'desc') {
			i = this.trs_length - 1 - i;
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.trs_tosort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.trs_tosort[left].value + '' <= center.value + '') {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value + '' > center.value + '') {
						right--;
					}
				} else {
					while (left <= right && this.trs_tosort[left].value <= center.value) {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value > center.value) {
						right--;
					}
				}

				if (left < right) {
					temp = this.trs_tosort[right];
					this.trs_tosort[right] = this.trs_tosort[left];
					this.trs_tosort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.trs_tosort[right];
			this.trs_tosort[right] = this.trs_tosort[first];
			this.trs_tosort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	create_dropdown: function create_dropdown() {
		this._thead.clone().inject(this._thead, 'after');

		this._sort_display = new Element('.sort_display');
		this._sort_display.inject(this._thead, 'top');

		this._thead.removeClass('thead').addClass('styled_select fake');

		new Element('.clearfix').inject(this._element, 'before').adopt(this._thead);

		this._sorters.each(function (_el) {
			var value = _el.getAttribute('data-value');

			if (value && value != '') {
				_el.set('html', value);
			}

			_el.setProperty('class', 'dropdown_item');

			var data_sort = _el.getAttribute('data-sort');

			if (!data_sort || data_sort == '') {
				_el.dispose();
			}
		});

		this._sort_display.set('html', this._sorters[0].get('html'));

		this._list = this._thead.getElement('.tr').removeClass('tr').addClass('dropdown_list');

		this._list.setStyle('visibility', 'hidden');
		this.dd_height = this._list.getSize().y;
		this._list.setStyle('height', 0);

		this.dd_fx = new Fx.Morph(this._list, { duration: 100, link: 'cancel' });

		this._list.setStyle('visibility', 'visible');

		this._list.setStyle('bottom', this._list.getCoordinates().y * -1);

		this.add_dropdown_behavior();
	},

	add_dropdown_behavior: function add_dropdown_behavior() {
		this._sort_display.addEvents({
			'click': this.toggle_dropdown.bind(this)
		});

		this._sorters.each(function (_el) {
			_el.addEvent('click', function () {
				this.toggle_dropdown();
				this._sort_display.set('html', _el.get('html'));
			}.bind(this));
		}.bind(this));

		$(document.body).addEvent('click:relay(div)', function (e, _element) {
			if (this._sort_display !== _element) {
				this.toggle_dropdown(0);
			}
		}.bind(this));
	},

	toggle_dropdown: function toggle_dropdown(height) {
		if (height == 0 || this._list.getSize().y > 0) {
			this.dd_fx.start({ 'height': 0 });
		} else {
			this.dd_fx.start({ 'height': this.dd_height });
		}
	},

	reinitialize: function reinitialize() {
		if (this._sorters) {
			this._sorters.each(function (_el) {
				_el.removeEvents();
			});

			this._prev_sorter = this._thead.getElement('.asc') || this._thead.getElement('.desc');
		}

		this.initialize();
	},

	add_tr_events: function add_tr_events() {
		var self = this;
		var _current_tr;
		var _current_el;

		if (Core.is_touch_supported()) {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click() {
						_el.toggleClass('_active');

						if (_current_el && _current_el !== _el) {
							_current_el.removeClass('_active');
						}

						_current_el = _el;
					}
				});

				$(document.body).addEvents({
					'touchstart:relay("*")': function touchstartRelay(e, _el) {
						if (!_el || _el != self._element && !_el.getParent('.w_divtable')) {
							if (typeof _current_el !== 'undefined' && _current_el) {
								_current_el.removeClass('_active');
							}
						}
					}
				});
			});
		} else {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click(e) {
						if (_el.get('data-href')) {
							//stop when user clicked an anchor element
							if (e && e.target && (e.target.get('href') || e.target.getParent().get('href'))) return;

							window.location = _el.get('data-href');
						}
					},
					'mouseover': function mouseover() {
						if (_current_tr && _current_tr !== _el) {
							_current_tr.removeClass('_active');
						}

						_el.addClass('_active');

						_current_tr = _el;
					},

					'mouseleave': function mouseleave() {
						_el.removeClass('_active');
					}
				});
			});
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var Highstock = new Class({
	Implements: [Events, Options],

	options: {
		colors: ['#6aade1', '#aca000', '#008c99', '#c03e62', '#494a66', '#ff6a00'],

		containerId: null,

		chart: {
			chart: {
				renderTo: 'chart_container'
			},

			rangeSelector: {
				selected: 5,

				inputStyle: {
					color: '#355672',
					// fontWeight: 'bold',
					fontSize: '13px'
				},

				inputDateFormat: '%m/%d/%Y',
				inputEditDateFormat: '%m/%d/%Y'
			},

			credits: {
				enabled: false
			},

			xAxis: {
				ordinal: false,
				title: {
					text: null
				},
				minRange: 3600000 * 24 * 14 //two weeks
			},

			yAxis: {
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: null
				},

				labels: {
					align: 'left',
					x: 0
				},

				min: 0,
				gridLineDashStyle: 'dash',
				gridLineColor: '#666',
				endOnTick: false,
				showLastLabel: true,
				opposite: false
			},

			navigator: {
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 150,
					ordinal: false,
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					}
				},

				series: {
					color: '#008C99'
				}
			},

			plotOptions: {
				series: {
					animation: true
				},

				line: {
					dataGrouping: {
						enabled: false,
						dateTimeLabelFormats: {
							day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
							week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
						}
					}
				}
			},

			scrollbar: {
				barBackgroundColor: '#008C99',
				rifleColor: '#fff',
				buttonBackgroundColor: '#008C99',
				buttonArrowColor: '#fff'
			}
		},

		tooltip_title: null
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);

		this._element = element;

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var x_label = this._element.getAttribute('data-x-label');
		var y_label = this._element.getAttribute('data-y-label');

		if (x_label && x_label.trim() != '') {
			this.options.chart.xAxis.title.text = x_label;
		}

		if (y_label && y_label.trim() != '') {
			this.options.chart.yAxis.title.text = y_label;
		}

		this._chart_options = document.getElements('.chart_options li');
		this._veil = this._element.getElement('.veil');

		var rpc;
		this.series_options = new Array(this._chart_options.length);

		if (this._chart_options) {
			this._chart_options.each(function (_el, i) {
				if (!_el.hasClass('disabled')) {
					_el.setStyles({
						'color': this.options.colors[i],
						'border-color': this.options.colors[i]
					});
				}
			}.bind(this));

			this.rpcs = [];
			this._chart_options.each(function (e) {
				this.rpcs.push(e.getAttribute('data-rpc'));
			}.bind(this));

			rpc = this.rpcs[0];

			this._chart_options.each(function (e, i) {
				if (!e.hasClass('disabled')) {
					e.addEvent('click', function () {
						if (!e.hasClass('selected')) {
							if (this.waiting) return;

							document.body.style.cursor = 'wait';
							var rpc = e.getAttribute('data-rpc');

							if (rpc && rpc !== '') {
								this.add_series_option(e, i);
							} else {
								this.show_warning();
							}
						} else {
							this.hide_series_option(i);

							e.setStyles({
								'color': this.options.colors[i],
								'background-color': '#fff'
							});
						}
					}.bind(this));
				} else {
					e.addClass('inactive');
				}
			}.bind(this));
		}

		rpc = rpc || this._element.getAttribute('data-rpc');

		if (rpc && rpc !== '') {
			this.rpc_request(rpc, this.post_rpc.bind(this));
		}
	},

	rpc_request: function rpc_request(url, success) {
		var self = this;

		if (this._veil) {
			this._veil.show();
		}

		this.remote = new Remote({
			rpc: url,
			method: 'get',
			onSuccess: success,
			onError: function onError() {
				self.show_warning(true);
			}
		});
	},

	show_warning: function show_warning(permanent_msg) {
		if (!this._err_msg) {
			this._err_msg = new Element('div', { 'class': 'err_msg', 'text': 'No data available. Please try again later.' });
			this._err_msg.inject(this._element, 'before');
		}

		this._err_msg.fade('in');

		if (!permanent_msg) {
			(function () {
				this._err_msg.fade('out');
			}).bind(this).delay(3000);
		}

		this.fireEvent('warning');
	},

	add_series_option: function add_series_option(option, i) {
		var name = option.get('text');

		if (!this.series_options[i]) {
			this.waiting = true;

			this.rpc_request(option.getAttribute('data-rpc'), function () {
				this.series_options[i] = {
					name: name,
					data: this.remote.get_data().data,
					color: this.options.colors[i]
				};

				if (this.chart) {
					this.chart.addSeries(this.series_options[i]);
				}

				option.setStyles({
					'color': '#fff',
					'background-color': this.options.colors[i]
				});

				option.addClass('selected');

				if (this._veil) {
					this._veil.hide();
				}

				this.waiting = false;
			}.bind(this));
		} else {
			this.chart.addSeries(this.series_options[i]);
			option.addClass('selected');

			option.setStyles({
				'color': '#fff',
				'background-color': this.options.colors[i]
			});

			if (this._veil) {
				this._veil.hide();
			}

			this.waiting = false;
		}

		document.body.style.cursor = 'default';
	},

	hide_series_option: function hide_series_option(i) {
		var name = this.series_options[i].name,
		    position;

		if (this.chart) {
			this.chart.series.each(function (e, i) {
				if (e.name === name) position = i;

				return;
			});

			this.chart.series[position].remove();
		}

		this._chart_options[i].removeClass('selected');
	},

	post_rpc: function post_rpc() {
		var data = this.remote.get_data();
		this.sales = this.remote.get_data().sales;

		if (data && data.data && this.remote.get_data().data.length > 1) {
			this.series_options[0] = {
				name: 'All Transactions',
				data: this.remote.get_data().data,
				color: this.options.colors[0]
			};

			if (this._chart_options) {
				this._chart_options[0].addClass('selected');

				this._chart_options[0].setStyles({
					'color': '#fff',
					'background-color': this.options.colors[0]
				});
			}

			this.create_chart();
		} else {
			this._chart_options.getParent().hide();
			this.show_warning(true);
		}

		if (this._veil) {
			this._veil.hide();
		}

		this.waiting = false;
	},

	create_chart: function create_chart() {
		var self = this;
		var series_options = this.series_options.clean();
		var chart_options = this.options.chart;
		var data_type = this.get_data_type();
		var _container = null;
		if (this.options.containerId) {
			_container = document.getElement('#' + this.options.containerId);
		} else {
			_container = document.getElement('.w_bldblimp #chart_container');
		}

		if (!_container) {
			_container = this._element.getElement('#chart_container');
		}

		this.move_rangeselector();

		chart_options = Object.merge(chart_options, {
			chart: {
				renderTo: _container
			},

			series: series_options,

			tooltip: {
				useHTML: true,
				style: {
					padding: '8px'
				},
				formatter: function formatter(e) {
					if (self.sales) {
						var data = self.sales[this.x];
						var content = '';
						var color = this.points[0].series.color;

						var counter = 0;
						Object.each(data, function (row, i) {
							content += row[0];
							if (counter < Object.getLength(data) - 1) {
								content += '<br /><hr style="margin: 10px 0; color: ' + color + ';" />';
							}
							counter++;
						});
					} else {
						var pageTitle = document.getElement('.page_title h1') ? document.getElement('.page_title h1').get('text') : '';
						var _title = self.options.tooltip_title || pageTitle;
						var total_points = this.points.length;
						var content = '';
						content += '<div class="series_name" style="border-bottom-color:' + this.points[0].series.color + '">' + _title + '</div><br/>' + 'Value on ' + '<b>' + Highcharts.dateFormat('%b %e, %Y', this.x) + '</b><br/><br/>';

						if (total_points > 1) {
							content += data_type + ' price / ft<sup>2</sup> of : <br/>';
						}

						this.points.each(function (e, i) {
							var point = e.point;
							var amount = e.point.series.options.data[e.point.index][2] ? ' (' + e.point.series.options.data[e.point.index][2] + ')' : '';

							if (total_points > 1) {
								content += '<span style="color:' + point.series.color + '; margin-left:20px;">' + point.series.name + amount + '</span>: <b>$' + Highcharts.numberFormat(e.y, 0) + '</b> <br/>';
							} else if (self._element.getAttribute('data-price-type') == 'closing') {
								content += data_type + ' closing price of <span style="color:' + point.series.color + '">' + point.series.name + amount + '</span>: <b>$' + Highcharts.numberFormat(e.y, 0) + '</b> <br/>';
							} else {
								content += data_type + ' price / ft<sup>2</sup> of <span style="color:' + point.series.color + '">' + point.series.name + amount + '</span>: <b>$' + Highcharts.numberFormat(e.y, 0) + '</b> <br/>';
							}
						});
					}

					return content;
				}
			},

			yAxis: {
				labels: {
					formatter: function formatter() {
						return '$' + Core.add_commas(this.value);
					}
				}
			}
		});

		this.chart = new Highcharts.StockChart(chart_options, function (chart) {
			setTimeout(function () {
				var _input_group = this._element.getElement('.highcharts-input-group');
				var _inputs = this._element.getElements('input.highcharts-range-selector', '#' + chart.options.chart.renderTo);

				if (_input_group) {
					// this is a workaround. close event from Date Picker widget is triggerred when clicking the input Date
					// need to cancel it.
					_input_group.addEvent('click', function (e) {
						e.stop();
					});
				}

				if (_inputs && _inputs.length > 1) {
					var min_date = new Date().parse(_inputs[0].get('value'));
					var max_date = new Date().parse(_inputs[1].get('value'));
				}

				_inputs.each(function (_el, i) {
					var min = min_date.clone();
					var max = max_date.clone();

					var dp = new Picker.Date(_el, {
						timePicker: true,
						draggable: false,
						minDate: i === 0 ? min : min.increment('day', 15),
						maxDate: i === 1 ? max : max.decrement('day', 15),
						pickOnly: 'days',
						pickerClass: 'datepicker_vista',
						format: "%Y-%m-%d",
						useFadeInOut: true,
						onSelect: function onSelect(dateText, input) {
							input.onchange();
							input.onblur();

							if (i === 0) {
								datepickers[1].options.minDate = dateText.increment('day', 15);
							} else if (i === 1) {
								datepickers[0].options.maxDate = dateText.decrement('day', 15);
							}
						}
					});

					datepickers.push(dp);

					_el.addEvent('focus', function () {
						datepickers.each(function (dp, j) {
							if (i !== j) {
								dp.hide();
							}
						});
					});
				});
			}.bind(this), 0);
		}.bind(this));
	},

	get_data_type: function get_data_type() {
		var rpc_string = this.remote.options.rpc;
		var p = rpc_string.contains('&p=');
		var show = rpc_string.contains('&show');

		if (p || show) {
			if (p) {
				data_type = 'Median';
			}

			if (show) {
				var rpc_string = this.remote.options.rpc;
				var start = rpc_string.indexOf('show');
				var end = rpc_string.lastIndexOf('&');
				var show_param = rpc_string.substring(start, end);
				var data_type = show_param.substring(show_param.indexOf('=') + 1);

				data_type = data_type == 'avg' ? 'Average' : 'Median';
			}

			return data_type;
		}

		data_type = 'Average';

		return data_type;
	},

	move_rangeselector: function move_rangeselector() {
		// To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 10
				});

				leftPosition += this.zoomText.getBBox().width + 20;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	}
});

var datepickers = [];
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.1: '*'
...
*/
var Opener = new Class({
	Implements: [Options, Events],
	options: {
		close_ability: false,
		no_toggler: false,
		animate: true
	},

	initialize: function initialize(toggler, toshow, options) {
		this.setOptions(options);

		if (this.options.no_toggler == false && toggler && toshow) {
			this._toggler = toggler;
			this._toshow = toshow;
			this.build();
		} else if (this.options.no_toggler == true && toshow) {
			this._toshow = toshow;
			this.build();
		}
	},

	build: function build() {
		this.pos = this._toshow.getStyle('position');

		if (this.options.no_toggler == false) {
			var rpc = this._toggler.getProperty('data-rpc');

			if (!rpc || rpc == '') {
				this._toggler.addEvent('click', this.toggle_cnt.bind(this));

				this.get_size();

				if (this._toggler.getProperty('type') && this._toggler.getProperty('type') != '') {
					this._toggler.addEvent('focus', this.toggle_cnt.bind(this));
				} else {
					var _input = this._toggler.getElement('input');

					if (_input) {
						_input.addEvent('focus', this.toggle_cnt.bind(this));
					}
				}
			} else {
				this._toggler.addEvent('click', function (e) {
					if (e && e.stop) e.stop();

					if (!this.remote && !this.data) {
						this.remote = new Remote({
							rpc: rpc,
							method: 'get',
							onSuccess: this.process_rpc.bind(this)
						});
					} else {
						this.fireEvent('ready');
						this.toggle_cnt();
					}
				}.bind(this));
			}
		} else {
			this.get_size();
		}
	},

	get_size: function get_size() {
		if (!this.options.animate) {
			this._toshow.hide();
			return;
		}

		this._toshow.setStyles({
			position: 'absolute',
			visibility: 'hidden',
			overflow: 'hidden'
		});

		this.margin_t = this._toshow.getStyle('marginTop').toInt();
		this.margin_b = this._toshow.getStyle('marginBottom').toInt();
		this.padding_t = this._toshow.getStyle('paddingTop').toInt();
		this.padding_b = this._toshow.getStyle('paddingBottom').toInt();
		this.height = this._toshow.getComputedSize().height - this.padding_t - this.padding_b - this.margin_t - this.margin_b;

		this._toshow.setStyles({
			position: this.pos,
			height: 0,
			marginTop: 0,
			marginBottom: 0,
			paddingTop: 0,
			paddingBottom: 0,
			visibility: 'visible'
		});
	},

	process_rpc: function process_rpc() {
		if (!this.data) this.data = this.remote.get_data();

		this.fireEvent('ready');

		this.get_size();
		this.toggle_cnt();
	},

	toggle_cnt: function toggle_cnt() {
		this.tween = new Fx.Morph(this._toshow, { duration: 300 });

		if (!this.open || this.open == false) {
			this.open_cnt();
		} else {
			this.close_cnt();
		}
	},

	open_cnt: function open_cnt() {
		if (this.open) return;

		if (!this.options.animate) {
			this._toshow.show();

			if (this._toggler) {
				this._toggler.addClass('active');
			}
		} else {
			this.tween.start({
				'marginTop': this.margin_t,
				'marginBottom': this.margin_b,
				'paddingTop': this.padding_t,
				'paddingBottom': this.padding_b,
				'height': this.height
			}).chain(function () {
				if (this._toggler) {
					this._toggler.addClass('active');
				}
			}.bind(this));

			(function () {
				this._toshow.setStyles({
					'height': 'auto',
					'overflow': 'visible',
					'display': 'block'
				});
			}).bind(this).delay(400);
		}

		this.open = true;
	},

	close_cnt: function close_cnt() {
		if (!this.open) return;

		if (!this.options.animate) {
			this._toshow.hide();
		} else {
			if (this.options.close_ability) {
				this._toshow.setStyles({
					'overflow': 'hidden',
					'height': this._toshow.getSize().y
				});

				this.tween.start({
					'marginTop': 0,
					'marginBottom': 0,
					'paddingTop': 0,
					'paddingBottom': 0,
					'height': 0
				});
			}
		}

		if (this._toggler) {
			this._toggler.removeClass('active');
		}

		this.open = false;
	}
});
'use strict';

Page.Bss = new Class({
	Extends: Page,
	build: function build() {
		this.parent();

		this.get_stalker_info();
		this.fill_nav_title();

		this.set_sales_data();
		this.set_available_apts();
		this.set_similar_buildings();
		//this.set_floorplans();
		this.set_all_units();
		this.set_sell();
		this.set_contact();
		this.set_off_market_deals();

		var __add_content = function __add_content(opener, container) {
			var data = opener.data,
			    content = '';

			if (data && data.content) {
				content = data.content;
			}

			if (content != '') {
				container.set('html', content);

				new Shrinker(container.getParent('.summary_item'), { min_height: 470, single_opened: false,
					onShrink: function onShrink() {
						this._toggler.set('html', 'Show More');
					},
					onUnshrink: function onUnshrink() {
						this._toggler.set('html', 'Show Less');
					}
				});
			} else {
				var _parent = container.getParent('.all_sales');
				var _select = document.getElement('.head .w_styled_select');
				if (_parent && _select) {
					_select.hide();
				}
			}
		};

		var _av_on = document.getElements('li.average_on'),
		    _me_on = document.getElements('li.median_on'),
		    _av_act_on = document.getElements('li.average_actual_on'),
		    _me_act_on = document.getElements('li.median_actual_on'),
		    _summary = document.getElement('.summary');

		if (_av_on) {
			_av_on.addEvent('click', function (e) {
				//e.preventDefault();

				if (_summary) _summary.removeClass('median');
				_summary.removeClass('median_act');
				_summary.removeClass('average_act');
			});
		}

		if (_me_on) {
			_me_on.addEvent('click', function (e) {
				e.preventDefault();

				if (_summary) _summary.addClass('median');
				_summary.removeClass('median_act');
				_summary.removeClass('average_act');
			});
		}

		if (_av_act_on) {
			_av_act_on.addEvent('click', function (e) {
				//e.preventDefault();

				if (_summary) _summary.removeClass('median');
				_summary.removeClass('median_act');
				_summary.addClass('average_act');
			});
		}

		if (_me_act_on) {
			_me_act_on.addEvent('click', function (e) {
				e.preventDefault();

				if (_summary) _summary.removeClass('median');
				_summary.addClass('median_act');
				_summary.removeClass('average_act');
			});
		}

		var data_type = _summary.get('data-type');

		if (data_type == 2 || data_type == 7) {
			_av_on.fireEvent('click');
		} else {
			_av_act_on.fireEvent('click');
		}

		var _all_sales = document.getElement('.all_sales');

		if (_all_sales) {
			var _toggler = _all_sales.getElement('.resume'),
			    _toshow = _all_sales.getElement('.w_opener');

			var opener = new Opener(_toggler, _toshow, { close_ability: false });
			opener.addEvent('ready', function () {
				if (!opener.scrollable) __add_content(opener, _toshow);

				opener.scrollable = true;

				// click event for the content of the summary item

				var _trs = _toshow.getElements('.tr');

				_trs.each(function (_tr) {
					_tr.addEvents({
						click: function click() {
							;
							if (_tr.get('data-url')) window.location = _tr.get('data-url');
						},
						mouseenter: function mouseenter() {
							if (_tr.get('data-url') == '' || !_tr.get('data-url')) _tr.setStyle('cursor', 'default');
						}
					});
				});
			});

			opener._toggler.fireEvent('click');

			_toggler.addEvent('click', function () {
				if (_toggler.get('data-url')) window.location = _toggler.get('data-url');
			});
		}

		var _summaries = document.getElements('.summary_item');

		if (_summaries && _summaries.length > 0) {
			_summaries.each(function (_el, i) {
				var _toggler = _el.getElement('.resume'),
				    _toshow = _el.getElement('.w_opener');

				var opener = new Opener(_toggler, _toshow, { close_ability: false });
				opener.addEvent('ready', function () {
					if (!opener.scrollable) __add_content(opener, _toshow);

					opener.scrollable = true;

					var _trs = _toshow.getElements('.tr');

					_trs.each(function (_tr) {
						_tr.addEvents({
							click: function click() {
								;
								if (_tr.get('data-url')) window.location = _tr.get('data-url');
							},
							mouseenter: function mouseenter() {
								if (_tr.get('data-url') == '' || !_tr.get('data-url')) _tr.setStyle('cursor', 'default');
							}
						});
					});
				});
				opener._toggler.fireEvent('click');
			});
		} else {
			document.getElement('.summary .breakdown').hide();
		}

		new Highstock(document.getElement('.w_highstock'), {
			onWarning: function onWarning() {
				var pricingGraph = document.getElement('.pricing_graph');
				pricingGraph.hide();
				var pricingGraphTitle = document.getElement('.pricing_graph_title');
				pricingGraphTitle.hide();
			}
		});

		//this.add_alert_link();
		this.add_save_link();
		this.add_share_link();
		//this.bottom_bar();
		this.show_top_nav_contact();
		this.building_stalker_data();
	},
	building_stalker_data: function building_stalker_data() {
		var _info = document.getElement('.stalker_info');
		var building_stalker = document.getElement('.persist_nav.building');
		var building_name = _info.getElement('input[name="build_name"]').value;
		var building_address = _info.getElement('input[name="build_address"]').value;

		// Doorman?
		var is_doorman = _info.getElement('input[name="is_doorman"]').value;

		// Sales history removal
		var is_sales_history = _info.getElement('input[name="is_sales_history"]').value;
		if (!is_sales_history) {
			building_stalker.getElement('.sale-history').remove();
		}

		// Ratings removal
		var is_ratings = _info.getElement('input[name="is_ratings"]').value;
		if (!is_ratings) {
			building_stalker.getElement('.ratings').remove();
		}

		var build_type = _info.getElement('input[name=build_type]').value.capitalize();
		var build_hood = _info.getElement('input[name=map_name]').value;
		if (building_name) {
			building_stalker.getElement('.title').set('text', building_name + ', ' + building_address);
		} else {
			building_stalker.getElement('.title').set('text', building_address);
		}
		building_stalker.getElement('.bldg-type').set('text', (is_doorman ? 'Doorman ' : '') + build_type + ' in ' + build_hood);

		var apts_sale = document.getElement('input[name="apts_sale"]').value;
		var apts_rent = document.getElement('input[name="apts_rent"]').value;
		var apts_num = apts_sale + apts_rent;
	},

	show_top_nav_contact: function show_top_nav_contact() {
		var buttonContact = document.getElement('[data-popup-name="contact-popup"');
		var buttonContactTopNav = document.getElement('.button-contact-top');
		if (buttonContact && buttonContactTopNav) {
			buttonContactTopNav.removeClass('none');
		}
	},
	// bottom_bar: () => {
	// 	let triggerElement = document.getElement('.content');
	// 	Core.bottom_bar(triggerElement, 150);
	// },

	add_alert_link: function add_alert_link() {
		var _alertButton = document.getElement('.alert-button-container .building-alert');
		this._stalker_alert_link = document.getElement('.w_stalker .persist_nav.building .links-icons');
		if (this._stalker_alert_link && _alertButton) {
			_alertButton.inject(this._stalker_alert_link);
		}
	},

	add_save_link: function add_save_link() {
		var _alertButton = document.querySelector('.alert-button-container .building-alert2');
		this._stalker_alert_link = document.querySelector('.w_stalker .persist_nav.building .other-icons');
		if (this._stalker_alert_link && _alertButton) {
			var clonedAlertButton = _alertButton.cloneNode(true);
			this._stalker_alert_link.appendChild(clonedAlertButton);
		}
	},

	add_share_link: function add_share_link() {
		var _shareButton = document.querySelector('.alert-button-container .link-icon.email');
		this._stalker_alert_link = document.querySelector('.w_stalker .persist_nav.building .other-icons');
		if (this._stalker_alert_link && _shareButton) {
			var clonedShareButton = _shareButton.cloneNode(true);
			this._stalker_alert_link.appendChild(clonedShareButton);
		}
	},

	get_stalker_info: function get_stalker_info() {
		var _info = document.getElement('.stalker_info');

		this.apt_sale = _info.getElement('input[name=apts_sale]').get("value");
		this.apt_rent = _info.getElement('input[name=apts_rent]').get("value");
		this.build_name = _info.getElement('input[name=build_name]').get("value");
		this.build_address = _info.getElement('input[name=build_address]').get("value");
		this.build_type = _info.getElement('input[name=build_type]').get("value").capitalize();
		this.build_predev_concept = _info.getElement('input[name=build_predev_concept]').get("value");
		this.map_link = _info.getElement('input[name=map_link]').get("value");
		this.map_name = _info.getElement('input[name=map_name]').get("value");
		this.apt_sale_url = _info.getElement('input[name=apts_sale_url]').get("value");
		this.all_units_url = _info.getElement('input[name=all_units_url]').get("value");
		this.similar_buildings_url = _info.getElement('input[name=similar_buildings_url]').get("value");
		this.sales_history_url = _info.getElement('input[name=sales_history_url]').get("value");
		this.is_sales_history = _info.getElement('input[name=is_sales_history]').get("value");
		this.floorplans_url = _info.getElement('input[name=floorplans_url]') ? _info.getElement('input[name=floorplans_url]').get("value") : '';
		this.sell_url = _info.getElement('input[name=sell_url]') ? _info.getElement('input[name=sell_url]').get("value") : '';
		this.building_total_units = _info.getElement('input[name=building_total_units]') ? _info.getElement('input[name=building_total_units]').get("value") : '0';
	},

	fill_nav_title: function fill_nav_title() {
		var _stalker_title = document.getElement('.w_stalker .nav_title');

		var building_stalker = document.getElement('.persist_nav.building');
		var _info = document.getElement('.stalker_info');
		var is_doorman = _info.getElement('input[name="is_doorman"]').value;
		var build_type = _info.getElement('input[name=build_type]').value.capitalize();
		var build_hood = _info.getElement('input[name=map_name]').value;
		building_stalker.getElement('.bldg-type').set('text', (is_doorman ? 'Doorman ' : '') + build_type + ' in ' + build_hood);

		// links
		var navItems = document.querySelectorAll('.building_nav ul li');
		var bldgFullUrl = document.querySelector('input[name="bldg_full_url"]').value;

		navItems.forEach(function (item) {
			item.addEventListener('click', function () {
				var targetId = this.getAttribute('data-target');
				if (targetId) {
					var fullUrlWithHash = bldgFullUrl + '#' + targetId;
					// redirect to hash
					window.location.href = fullUrlWithHash;
				}
			});
		});

		if (!_stalker_title) {
			return;
		}

		var _stalker_info = _stalker_title.getElement('._info');
		var _stalker_build_type = _stalker_title.getElement('._type');
		// var _stalker_map_link = _stalker_title.getElement('._map');

		// var _stalker_build_name = _stalker_title.getElement('._name');
		// check the building name
		// if (this.build_name === ''){
		// 	this.build_name = this.build_address;
		// 	_stalker_build_name.set('text', this.build_name);
		// } else {
		// 	// check the address
		// 	if (this.build_address === '') {
		// 		_stalker_build_name.set('text', this.build_name);
		// 	} else {
		// 		_stalker_build_name.set('text', this.build_name + ', ' + this.build_address);
		// 	}
		// }

		var buildingTypeAndHood = void 0;
		if (this.build_type != '') {
			buildingTypeAndHood = this.build_type;
		}
		if (this.map_name != '') {
			if (this.build_type != '') {
				buildingTypeAndHood += ' in ';
			}
			buildingTypeAndHood += this.map_name;
		}
		_stalker_build_type.set('text', buildingTypeAndHood);
	},

	set_off_market_deals: function set_off_market_deals() {
		var _off_market_deals = document.getElement('.w_stalker ._info .button-off-market-deals');

		if (_off_market_deals) {
			if (this.build_predev_concept == "0" && (this.build_type === 'Condo' || this.build_type === 'Co-Op' || this.build_type === 'Condop')) {
				// nothing to do
			} else {
				_off_market_deals.getParent().dispose();
			}
		}
	},

	set_available_apts: function set_available_apts() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _aval_apts = document.getElement('.w_stalker ._info ._aval_apts');

		if (apts > 0 && _aval_apts && _aval_apts.getElement('._value')) {
			_aval_apts.getElement('._value').set('text', apts);
			_aval_apts.getElement('._text').set('text', 'Available Apt' + (apts > 1 ? 's' : ''));
			_aval_apts.set('href', this.apt_sale_url);
		} else if (_aval_apts) {
			_aval_apts.getParent().dispose();
		}
	},

	set_sales_data: function set_sales_data() {
		var _sales_history = document.getElement('.w_stalker ._info ._sales_history');

		if (_sales_history && this.is_sales_history === '1') {
			_sales_history.set('href', this.sales_history_url);
		} else if (_sales_history) {
			_sales_history.getParent().dispose();
		}
	},

	set_similar_buildings: function set_similar_buildings() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _similar_buildings = document.getElement('.w_stalker ._info ._similar_buildings');

		if (_similar_buildings) {
			_similar_buildings.set('href', this.similar_buildings_url);
		} else if (_similar_buildings) {
			_similar_buildings.getParent().dispose();
		}
	},

	set_all_units: function set_all_units() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _all_units = document.getElement('.w_stalker ._info ._all_units');

		if (_all_units && this.all_units_url && this.build_predev_concept == "0") {
			_all_units.set('href', this.all_units_url);
		} else if (_all_units) {
			_all_units.getParent().dispose();
		}
	},

	set_floorplans: function set_floorplans() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _floorplans = document.getElement('.w_stalker ._info ._floorplans');

		if (_floorplans && this.floorplans_url) {
			_floorplans.set('href', this.floorplans_url);
		} else {
			_floorplans.getParent().dispose();
		}
	},

	set_sell: function set_sell() {
		var _sell = document.getElement('.w_stalker ._info ._sell');

		if (_sell) {
			if (_sell && this.sell_url && this.build_type !== 'No Fee Rental' && this.build_type !== 'Townhouse') {
				_sell.set('href', this.sell_url);
				Core.setBuildingSellData(_sell, this.building_total_units);
			} else {
				_sell.getParent().dispose();
			}
		}
	},

	set_contact: function set_contact() {
		var _contact = document.getElement('.w_stalker ._info .button-book-tour');

		if (_contact && this.build_type === 'No Fee Rental') {
			_contact.set('text', 'Contact');
		}
	}
});
//# sourceMappingURL=bss.js.map
